import { range } from 'lodash'

import type { CurriculumBasketType } from './curriculum-basket-type'
import type {
  CurriculumBasket,
  CurriculumBasketCourse
} from '../hooks/useCurriculumForm'

export const SEMESTERS = range(8)

export const EMPTY_SEMESTERS: CurriculumBasketCourse['semesters'] =
  SEMESTERS.map(() => ({
    isActive: false,
    hours: null
  }))

export const EMPTY_COURSE: CurriculumBasketCourse = {
  course: '',
  timeUnit: 'week',
  semesters: EMPTY_SEMESTERS
}

type BasketConfig = {
  minItems: number
  defaultValue: CurriculumBasketCourse[]
}

export const BASKET_CONFIG_BY_TYPE: Record<CurriculumBasketType, BasketConfig> =
  {
    select: {
      minItems: 2,
      defaultValue: [EMPTY_COURSE, EMPTY_COURSE]
    },
    focus: {
      minItems: 2,
      defaultValue: [EMPTY_COURSE, EMPTY_COURSE]
    },
    regular: {
      minItems: 1,
      defaultValue: [EMPTY_COURSE]
    }
  }

export const EMPTY_BASKET: CurriculumBasket = {
  type: 'regular',
  courses: BASKET_CONFIG_BY_TYPE.regular.defaultValue
}
